import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { CiReceipt } from 'react-icons/ci';
import { VscGitPullRequestCreate } from 'react-icons/vsc';
import { SiGitbook } from 'react-icons/si';
import { GiServerRack } from 'react-icons/gi';

export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];

const tiles = [
  {
    sNo: 1,
    isLink: true,
    link: '/common/createStoreSetup',
    clauseNo: 5,
    icon: <VscGitPullRequestCreate size="5rem" color="#1864ab" />,
    p: 'STORE',
    span: 'SETUP',
    isIcon: true,
  },
  {
    sNo: 2,
    isLink: true,
    link: '/common/mrrReport/list',
    clauseNo: 5,
    icon: <CiReceipt size="6rem" color="#343a40" />,
    p: 'MRR',
    span: 'Report',
    isIcon: true,
  },
  {
    sNo: 2,
    isLink: true,
    link: '/common/storeregister/part/list',
    clauseNo: 5,
    icon: <SiGitbook size="6rem" color="#1864ab" />,
    p: 'Stock',
    span: 'Register',
    isIcon: true,
  },
  {
    sNo: 2,
    isLink: true,
    link: '/common/viewStore',
    clauseNo: 5,
    icon: <GiServerRack size="6rem" color="#087f5b" />,
    p: 'Store',
    span: 'OVerview',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="STORE MANAGEMENT   * Under Construction please don't fill data" />
      <RenderTiles
        tilesObj={tiles}
        height={'100vh'}
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
